export default __webpack_public_path__ + "static/media/box1.08e285d9.jpeg";